import './StandupBlock.css';
import StandupFullScreen from './StandupFullScreen.js'
import FocusBlock from '../subwidgets/FocusBlock.js';
import React, { useState } from "react";

function StandupBlock(props) {
    const [showFullScreen, setShowFullScreen] = useState(false)
    const [finished, setFinished] = useState(false)

    return (
        <div className="">
            {showFullScreen && !finished &&
            <StandupFullScreen setFinished={setFinished} tasks={props.tasks} setTasks={props.setTasks} setShowFullScreen={setShowFullScreen} userProfile={props.userProfile}/>
            }
            {!finished && 
                <p onClick={() => setShowFullScreen(true)} className="standupButton"> start standup</p>
            }
            {finished && 
                <FocusBlock userProfile={props.userProfile} tasks={props.tasks} setTasks={props.setTasks}/>
            }
        </div>
    )
}

export default StandupBlock;